(() => {
  const root = document.querySelector('[data-powdi-product]');
  if (!root) return;

  const packSelect = root.querySelector('[data-pack-select]');
  const sizeSelect = root.querySelector('[data-size-select]');
  const packLabel = root.querySelector('[data-pack-label]');
  const packSave = root.querySelector('[data-pack-save]');
  const isMix = root.dataset.mix === 'true';

  const parseJSON = (value, fallback) => {
    try {
      return JSON.parse(value);
    } catch (_error) {
      return fallback;
    }
  };

  const payloadEl = root.querySelector('[data-product-payload]');
  const product = parseJSON(payloadEl?.textContent, {});
  const variants = product.variants || [];
  const sellingPlanGroups = product.selling_plan_groups || [];
  const discountPct = Number(root.dataset.discount) || 0;
  const twoPack = root.dataset.twoPack === 'true';
  const packTiers = twoPack || root.dataset.packTiers === 'true';
  const qtyCards = root.dataset.qtyCards === 'true';
  const requiresPlan = root.dataset.requiresPlan === 'true';
  const moneyFormat = root.dataset.moneyFormat || '{{amount}} €';
  const saveLabel = root.dataset.saveLabel || 'Sutaupyk';
  const saveMoreLabel = root.dataset.saveMoreLabel || 'Sutaupyk dar';

  const paintSave = (el, label, pct) => {
    const value = Math.round(Number(pct) || 0);
    if (value <= 0) {
      el.hidden = true;
      el.replaceChildren();
      return;
    }
    const word = document.createElement('span');
    word.textContent = label;
    const amount = document.createElement('span');
    amount.textContent = `${value}%`;
    el.hidden = false;
    el.replaceChildren(word, amount);
  };
  const media = [...root.querySelectorAll('[data-product-media]')];
  const thumbs = [...root.querySelectorAll('[data-product-thumb]')];
  const dots = [...root.querySelectorAll('[data-product-dot]')];
  const variantInput = root.querySelector('[data-variant-id]');
  const sellingPlanInput = root.querySelector('[data-selling-plan]');
  const qtyInput = root.querySelector('[data-qty-input]');
  const qtyLabels = [...root.querySelectorAll('[data-qty-label]')];
  const ctaPrice = root.querySelector('[data-cta-price]');
  const sticky = root.querySelector('[data-sticky-cta]');
  const stickyPrice = root.querySelector('[data-sticky-price]');
  const purchaseCta = root.querySelector('[data-powdi-product-cta]');
  const freqSelect = root.querySelector('[data-freq-select]');
  const freqLabel = root.querySelector('[data-freq-label]');
  const atcButtons = [...root.querySelectorAll('[data-powdi-product-cta] button[name="add"], [data-sticky-submit]')];
  const mobileQuery = window.matchMedia('(max-width: 767px)');

  let mediaIndex = 0;
  let qty = Math.max(1, Number(qtyInput?.value) || 1);
  let purchaseMode = root.dataset.defaultMode || 'once';
  let currentVariant =
    variants.find((item) => String(item.id) === String(variantInput?.value)) || variants[0] || null;

  const formatMoney = (cents) => {
    const amount = (Number(cents) / 100).toFixed(2);
    const comma = amount.replace('.', ',');
    return moneyFormat
      .replace('{{amount_with_comma_separator}}', comma)
      .replace('{{amount_no_decimals}}', String(Math.round(Number(cents) / 100)))
      .replace('{{amount}}', comma);
  };

  const escapeHtml = (value) =>
    String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

  const planFromGroups = (planId) => {
    for (const group of sellingPlanGroups) {
      const match = (group.selling_plans || []).find((plan) => String(plan.id) === String(planId));
      if (match) return match;
    }
    return null;
  };

  const localizePlan = (raw) => {
    const text = String(raw || '').trim();
    const match = text.match(/^deliver every\s+(?:(\d+)\s+)?(week|month|day)s?\b/i);
    if (!match) return text;
    const count = Number(match[1] || 1);
    const unit = match[2].toLowerCase();
    if (unit === 'week') {
      if (count === 1) return 'Kiekvieną savaitę';
      if (count <= 9) return `Kas ${count} savaites`;
      return `Kas ${count} savaičių`;
    }
    if (unit === 'month') return count === 1 ? 'Kas 1 mėnesį' : `Kas ${count} mėnesius`;
    if (count === 1) return 'Kas 1 dieną';
    if (count <= 9) return `Kas ${count} dienas`;
    return `Kas ${count} dienų`;
  };

  const planLabel = (plan) => localizePlan(plan?.options?.[0]?.value || plan?.name || '');

  const perDaySuffix = root.querySelector('[data-per-day-suffix]')?.dataset.perDaySuffix || '/ dieną';

  const spanFromText = (raw) => {
    const text = String(raw || '').toLowerCase();
    const match = text.match(/(\d+)\s*(week|savait|savaič|month|mėnes|menes|day|dien)/);
    if (match) {
      const count = Number(match[1]);
      const unit = match[2];
      if (unit.startsWith('w') || unit.startsWith('s')) return count * 7;
      if (unit.startsWith('d')) return count;
      return count * 30;
    }
    if (/\bevery\s+week\b/.test(text) || text.includes('kiekvieną savaitę') || text.includes('kas savaitę')) return 7;
    if (/\bevery\s+month\b/.test(text) || text.includes('kiekvieną mėnesį') || text.includes('kas mėnesį')) return 30;
    if (/\bevery\s+day\b/.test(text) || text.includes('kiekvieną dieną') || text.includes('kas dieną')) return 1;
    return 0;
  };

  const planSpanDays = (plan) => spanFromText(plan?.options?.[0]?.value) || spanFromText(plan?.name);

  const closestPlanId = (variant, days) => {
    const allocations = allocationsFor(variant);
    if (!allocations.length) return '';
    if (!days) return String(allocations[0].selling_plan_id);
    let bestId = String(allocations[0].selling_plan_id);
    let bestDiff = Infinity;
    allocations.forEach((allocation) => {
      const span = planSpanDays(planFromGroups(allocation.selling_plan_id));
      if (!span) return;
      const diff = Math.abs(span - days);
      if (diff < bestDiff) {
        bestDiff = diff;
        bestId = String(allocation.selling_plan_id);
      }
    });
    return bestId;
  };

  const allocationsFor = (variant) => variant?.selling_plan_allocations || [];

  const allocationFor = (variant, planId) =>
    allocationsFor(variant).find((item) => String(item.selling_plan_id) === String(planId));

  const selectedPlanId = () => {
    if (freqSelect?.value) return freqSelect.value;
    const fallback =
      sellingPlanInput?.dataset.defaultPlan || allocationsFor(currentVariant)[0]?.selling_plan_id || '';
    return fallback ? String(fallback) : '';
  };

  const subscribeCents = (variant, planId) => {
    const allocation = allocationFor(variant, planId);
    if (allocation?.price != null) return Number(allocation.price);
    const plan = planFromGroups(planId);
    const adjustment = plan?.price_adjustments?.[0];
    const price = Number(variant?.price) || 0;
    if (adjustment?.value_type === 'percentage') {
      return Math.round((price * (100 - Number(adjustment.value))) / 100);
    }
    if (discountPct > 0) return Math.round((price * (100 - discountPct)) / 100);
    return price;
  };

  const subscribeDiscountPct = (variant, planId) => {
    const plan = planFromGroups(planId);
    const adjustment = plan?.price_adjustments?.[0];
    if (adjustment?.value_type === 'percentage') return Number(adjustment.value) || 0;
    const price = Number(variant?.price) || 0;
    const subPrice = subscribeCents(variant, planId);
    if (price > 0 && price > subPrice) return Math.round(((price - subPrice) / price) * 100);
    return discountPct;
  };

  const syncFreqSelect = (preferredId) => {
    const allocations = allocationsFor(currentVariant);
    const currentId = preferredId || selectedPlanId();
    if (freqSelect) {
      if (allocations.length) {
        const options = allocations
          .map((allocation) => {
            const plan = planFromGroups(allocation.selling_plan_id);
            const selected = String(allocation.selling_plan_id) === String(currentId) ? 'selected' : '';
            return `<option value="${allocation.selling_plan_id}" ${selected}>${escapeHtml(planLabel(plan))}</option>`;
          })
          .join('');
        freqSelect.innerHTML = options;
        if (![...freqSelect.options].some((option) => option.selected) && freqSelect.options[0]) {
          freqSelect.options[0].selected = true;
        }
      } else if (!sellingPlanGroups.length) {
        freqSelect.innerHTML = '';
      }
    }
    const planId = selectedPlanId();
    if (sellingPlanInput && planId) sellingPlanInput.dataset.defaultPlan = planId;
    if (freqLabel && planId) freqLabel.textContent = planLabel(planFromGroups(planId));
  };

  const neutralizeAppSellingPlanInputs = () => {
    root.querySelectorAll('input[name="selling_plan"]:not([data-selling-plan])').forEach((input) => {
      input.disabled = true;
      input.removeAttribute('name');
    });
    document.querySelectorAll('.shopify_subscriptions_app_block_container input[name="selling_plan"]').forEach((input) => {
      input.disabled = true;
      input.removeAttribute('name');
    });
  };

  const productForm = root.querySelector('form[data-type="add-to-cart-form"]');
  if (productForm && 'MutationObserver' in window) {
    const observer = new MutationObserver(neutralizeAppSellingPlanInputs);
    observer.observe(productForm, { childList: true, subtree: true });
  }

  const syncSellingPlanInput = () => {
    if (!sellingPlanInput) return;
    if (purchaseMode === 'subscribe') {
      const planId = selectedPlanId();
      sellingPlanInput.disabled = !planId;
      sellingPlanInput.value = planId || '';
    } else {
      sellingPlanInput.disabled = true;
      sellingPlanInput.value = '';
    }
  };

  const packDiscountFor = (count) => {
    if (!packTiers) return 0;
    const n = Number(count) || 1;
    if (n === 2) return 5;
    return 0;
  };

  const packFaceLabel = (count) => {
    const n = Number(count) || 1;
    const teen = n % 100;
    const last = n % 10;
    let word = 'pakuočių';
    if (!(teen >= 11 && teen <= 19)) {
      if (last === 1) word = 'pakuotė';
      else if (last >= 2 && last <= 9) word = 'pakuotės';
    }
    return `${n} ${word}`;
  };

  const updatePackFace = () => {
    if (!packLabel) return;
    if (packSelect) {
      const matched = [...packSelect.options].find((option) => option.value === String(qty));
      if (matched) {
        packSelect.value = String(qty);
        packLabel.textContent = matched.textContent.trim();
      } else {
        packLabel.textContent = packFaceLabel(qty);
      }
      const pct = packDiscountFor(qty);
      if (packSave) {
        packSave.hidden = pct <= 0;
        packSave.textContent = pct > 0 ? `${saveLabel} ${pct}%` : '';
      }
      return;
    }
    if (sizeSelect) {
      const selected = sizeSelect.selectedOptions[0];
      if (selected) packLabel.textContent = selected.textContent.trim();
    }
  };

  const playSlideVideo = (slide) => {
    const video = slide.querySelector('video');
    if (!video || video.error) return;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    const start = () => {
      if (slide.hidden) return;
      const attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
    };
    if (video.readyState < 2) {
      video.preload = 'auto';
      video.addEventListener('loadeddata', start, { once: true });
      video.addEventListener('canplay', start, { once: true });
      video.load();
    }
    start();
  };

  const showMedia = (index) => {
    if (!media.length) return;
    mediaIndex = Math.min(media.length - 1, Math.max(0, index));
    media.forEach((slide, i) => {
      slide.hidden = i !== mediaIndex;
      slide.querySelectorAll('video').forEach((video) => {
        if (i !== mediaIndex) video.pause();
      });
    });
    playSlideVideo(media[mediaIndex]);
    const stageEl = root.querySelector('.powdi-product__stage');
    if (stageEl) stageEl.classList.toggle('is-video', Boolean(media[mediaIndex].querySelector('video')));
    thumbs.forEach((thumb, i) => {
      thumb.classList.toggle('is-active', i === mediaIndex);
    });
    const track = root.querySelector('.powdi-product__thumbs-track');
    const activeThumb = thumbs[mediaIndex];
    if (track && activeThumb) {
      const left = activeThumb.offsetLeft - (track.clientWidth - activeThumb.offsetWidth) / 2;
      track.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    }
    dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === mediaIndex);
    });
    const prevButtons = root.querySelectorAll('[data-gallery-prev]');
    const nextButtons = root.querySelectorAll('[data-gallery-next]');
    prevButtons.forEach((button) => button.classList.toggle('is-disabled', mediaIndex === 0));
    nextButtons.forEach((button) => button.classList.toggle('is-disabled', mediaIndex === media.length - 1));
  };

  const mediaForVariant = (variant) => {
    const imageId = variant?.featured_image?.id;
    if (!imageId) return;
    const match = media.findIndex((slide) => {
      return String(slide.dataset.imageId) === String(imageId);
    });
    if (match >= 0) showMedia(match);
  };

  const updateSupplyPrices = () => {
    const hasPlans = root.dataset.hasPlans === 'true';
    root.querySelectorAll('[data-supply]').forEach((card) => {
      const variant = variants.find((item) => String(item.id) === String(card.dataset.supply));
      if (!variant) return;
      const days = Number(card.dataset.days) || 0;
      const once = Number(variant.price) || 0;
      const compareAt = Number(variant.compare_at_price) || 0;
      const planId = card.classList.contains('is-active') ? selectedPlanId() : closestPlanId(variant, days);
      const sub = hasPlans ? subscribeCents(variant, planId) : once;
      const showSub = purchaseMode === 'subscribe' && hasPlans && sub > 0 && sub < once;
      const shown = showSub ? sub : once;
      const strike = showSub
        ? once > shown
          ? once
          : 0
        : compareAt > once
          ? compareAt
          : 0;
      const priceEl = card.querySelector('[data-supply-price]');
      const compareEl = card.querySelector('[data-supply-compare]');
      const dayEl = card.querySelector('[data-supply-perday]');
      const saveEl = card.querySelector('[data-supply-save]');
      const savePctEl = card.querySelector('[data-supply-save-pct]');
      if (priceEl) priceEl.textContent = formatMoney(shown);
      if (compareEl) {
        const showStrike = strike > shown;
        compareEl.hidden = !showStrike;
        if (showStrike) compareEl.textContent = formatMoney(strike);
      }
      if (dayEl) {
        if (days > 0 && shown > 0) {
          dayEl.hidden = false;
          dayEl.textContent = `${formatMoney(Math.round(shown / days))} ${perDaySuffix}`;
        } else {
          dayEl.hidden = true;
        }
      }
      if (saveEl) saveEl.hidden = true;
      if (savePctEl && showSub) savePctEl.textContent = String(subscribeDiscountPct(variant, planId));
    });
  };

  const placePurchasePanel = (variantId) => {
    const panel = root.querySelector('[data-purchase-panel]');
    const slot = root.querySelector(`[data-supply="${variantId}"] [data-supply-slot]`);
    if (panel && slot && panel.parentElement !== slot) slot.appendChild(panel);
    root.querySelectorAll('[data-supply]').forEach((card) => {
      card.classList.toggle('is-active', String(card.dataset.supply) === String(variantId));
    });
  };

  const placePackPanel = (count) => {
    const panel = root.querySelector('[data-purchase-panel]');
    const slot = root.querySelector(`[data-pack-card="${count}"] [data-supply-slot]`);
    if (panel && slot && panel.parentElement !== slot) slot.appendChild(panel);
    root.querySelectorAll('[data-pack-card]').forEach((card) => {
      const active = String(card.dataset.packCard) === String(count);
      card.classList.toggle('is-active', active);
      const button = card.querySelector('[data-pack-option]');
      if (button) button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  const updatePackCards = () => {
    if ((!packTiers && !qtyCards) || !currentVariant) return;
    const once = Number(currentVariant.price) || 0;
    const planId = selectedPlanId();
    const subUnit = subscribeCents(currentVariant, planId);
    const usingSub = purchaseMode === 'subscribe' && root.dataset.hasPlans === 'true' && subUnit > 0 && subUnit < once;
    root.querySelectorAll('[data-pack-card]').forEach((card) => {
      const count = Number(card.dataset.packCard) || 1;
      const full = once * count;
      const pct = packDiscountFor(count);
      const off = pct > 0 ? Math.floor((once * pct) / 100) * count : 0;
      const onceLine = full - off;
      const shown = usingSub ? subUnit * count : onceLine;
      const strike = usingSub ? once * count : off > 0 ? full : 0;
      const priceEl = card.querySelector('[data-pack-price]');
      const compareEl = card.querySelector('[data-pack-compare]');
      const saveEl = card.querySelector('[data-pack-save]');
      if (priceEl) priceEl.textContent = formatMoney(shown);
      if (compareEl) {
        const showStrike = strike > shown;
        compareEl.hidden = !showStrike;
        if (showStrike) compareEl.textContent = formatMoney(strike);
      }
      if (saveEl) saveEl.hidden = usingSub || pct <= 0;
      const vsEl = card.querySelector('[data-pack-vs]');
      if (vsEl) {
        vsEl.hidden = usingSub || off <= 0;
        const vsAmount = vsEl.querySelector('[data-pack-vs-amount]');
        if (vsAmount && off > 0) vsAmount.textContent = formatMoney(off);
      }
      const dayEl = card.querySelector('[data-pack-perday]');
      const days = Number(card.dataset.days) || 0;
      if (dayEl) {
        if (days > 0 && shown > 0) {
          dayEl.hidden = false;
          dayEl.textContent = `${formatMoney(Math.round(shown / days))} ${perDaySuffix}`;
        } else {
          dayEl.hidden = true;
        }
      }
    });
  };

  const updatePrices = () => {
    if (!currentVariant) return;
    const planId = selectedPlanId();
    const oncePrice = currentVariant.price;
    const compare = currentVariant.compare_at_price;
    const subPrice = subscribeCents(currentVariant, planId);
    const subPct = subscribeDiscountPct(currentVariant, planId);
    const pricedByQty = twoPack || isMix || qtyCards;
    const fullOnce = pricedByQty ? oncePrice * qty : oncePrice;
    const packPct = packDiscountFor(qty);
    const packOff = packPct > 0 ? Math.floor((oncePrice * packPct) / 100) * qty : 0;
    const lineOnce = fullOnce - packOff;
    const lineCompare = pricedByQty ? (packOff > 0 ? fullOnce : compare ? compare * qty : 0) : compare;
    const lineSub = twoPack || isMix ? subPrice * qty : subPrice;
    const lineSubStrike = twoPack || isMix ? oncePrice * qty : oncePrice;
    const usingSub = purchaseMode === 'subscribe';
    const available = Boolean(currentVariant.available);
    root.classList.toggle('is-sold-out', !available);
    root.querySelectorAll('[data-powdi-qty]').forEach((el) => {
      el.hidden = !available;
    });
    root.querySelectorAll('[data-powdi-atc-wrap]').forEach((el) => {
      el.hidden = !available;
    });
    root.querySelectorAll('[data-powdi-bis]').forEach((el) => {
      el.hidden = available;
    });

    root.querySelectorAll('[data-once-price]').forEach((el) => {
      el.textContent = formatMoney(lineOnce);
    });
    root.querySelectorAll('[data-once-compare]').forEach((el) => {
      const show = lineCompare && lineCompare > lineOnce;
      el.hidden = !show;
      if (show) el.textContent = formatMoney(lineCompare);
    });
    const oncePct = compare && compare > oncePrice
      ? Math.floor(((compare - oncePrice) / compare) * 100)
      : 0;
    root.querySelectorAll('[data-once-sale]').forEach((el) => {
      paintSave(el, saveLabel, oncePct);
    });
    root.querySelectorAll('[data-sub-price]').forEach((el) => {
      el.textContent = formatMoney(lineSub);
    });
    root.querySelectorAll('[data-sub-compare]').forEach((el) => {
      const show = lineSubStrike > lineSub;
      el.hidden = !show;
      if (show) el.textContent = formatMoney(lineSubStrike);
    });
    const alreadyOnSale = Boolean(compare && compare > oncePrice) || packPct > 0;
    root.querySelectorAll('[data-sub-save]').forEach((el) => {
      paintSave(el, alreadyOnSale ? saveMoreLabel : saveLabel, subPct);
    });
    const shownLine = usingSub ? lineSub : lineOnce;
    root.querySelectorAll('[data-sold-figure]').forEach((el) => {
      el.textContent = formatMoney(shownLine);
    });
    if (ctaPrice) ctaPrice.textContent = formatMoney(shownLine);
    if (stickyPrice) stickyPrice.textContent = formatMoney(shownLine);
    const priceNote = root.querySelector('[data-price-note]');
    if (priceNote) {
      const noteCompare = Number(currentVariant.compare_at_price) || 0;
      const notePrice = Number(currentVariant.price) || 0;
      const showNote = noteCompare > notePrice;
      priceNote.hidden = !showNote;
      if (showNote) {
        const noteTemplate = priceNote.dataset.priceNoteKind === 'bundle'
          ? priceNote.dataset.noteBundle
          : priceNote.dataset.noteSale;
        priceNote.textContent = String(noteTemplate || '')
          .replace('[compare]', formatMoney(noteCompare))
          .replace('[save]', formatMoney(noteCompare - notePrice))
          .replace('[price]', formatMoney(noteCompare));
      }
    }
    updateSupplyPrices();
    updatePackCards();
    atcButtons.forEach((button) => {
      button.disabled = !available;
    });
  };

  const setMode = (mode) => {
    const hasAllocations = allocationsFor(currentVariant).length > 0 || sellingPlanGroups.length > 0;
    if (mode === 'subscribe' && !hasAllocations && !requiresPlan) mode = 'once';
    if (mode === 'once' && requiresPlan) mode = 'subscribe';
    purchaseMode = mode;
    root.dataset.mode = mode;
    root.querySelectorAll('[data-purchase-option]').forEach((el) => {
      const active = el.dataset.purchaseOption === mode;
      el.classList.toggle('is-active', active);
    });
    root.querySelectorAll('[data-purchase-radio]').forEach((input) => {
      input.checked = input.value === mode;
    });
    syncSellingPlanInput();
    updatePrices();
  };

  const setVariant = (id) => {
    const next = variants.find((item) => String(item.id) === String(id));
    if (!next) return;
    currentVariant = next;
    if (variantInput) variantInput.value = next.id;
    root.querySelectorAll('[data-size-option]').forEach((el) => {
      const active = String(el.dataset.sizeOption) === String(next.id);
      el.classList.toggle('is-active', active);
      el.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    placePurchasePanel(next.id);
    const days = Number(root.querySelector(`[data-supply="${next.id}"]`)?.dataset.days) || 0;
    syncFreqSelect(days ? closestPlanId(next, days) : '');
    if (purchaseMode === 'subscribe' && !allocationsFor(next).length && !requiresPlan) {
      setMode('once');
    } else {
      syncSellingPlanInput();
      updatePrices();
    }
    mediaForVariant(next);
    updatePackFace();
  };

  const setQty = (value) => {
    qty = Math.max(1, Number(value) || 1);
    if (twoPack) qty = Math.min(2, qty);
    else if (qtyCards) qty = Math.min(3, qty);
    if (qtyInput) qtyInput.value = String(qty);
    qtyLabels.forEach((label) => {
      label.textContent = String(qty);
    });
    updatePackFace();
    placePackPanel(qty);
    updatePrices();
  };

  const syncSticky = (hidden) => {
    if (!sticky) return;
    const show = hidden && mobileQuery.matches;
    sticky.classList.toggle('is-visible', show);
    root.classList.toggle('has-sticky', show);
  };

  root.querySelectorAll('[data-gallery-prev]').forEach((button) => {
    button.addEventListener('click', () => showMedia(mediaIndex - 1));
  });
  root.querySelectorAll('[data-gallery-next]').forEach((button) => {
    button.addEventListener('click', () => showMedia(mediaIndex + 1));
  });
  thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => showMedia(i)));
  dots.forEach((dot, i) => dot.addEventListener('click', () => showMedia(i)));

  const stage = root.querySelector('.powdi-product__stage');
  if (stage && media.length > 1) {
    let swipe = null;
    let ignoreClick = false;
    stage.addEventListener(
      'click',
      (event) => {
        if (!ignoreClick) return;
        ignoreClick = false;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );
    stage.addEventListener('pointerdown', (event) => {
      ignoreClick = false;
      if (!event.isPrimary || event.button > 0) return;
      if (event.target.closest('button, a')) return;
      swipe = { id: event.pointerId, x: event.clientX, y: event.clientY };
    });
    stage.addEventListener('pointermove', (event) => {
      if (!swipe || swipe.id !== event.pointerId) return;
      const dx = event.clientX - swipe.x;
      const dy = event.clientY - swipe.y;
      if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
      if (Math.abs(dx) <= Math.abs(dy)) {
        swipe = null;
        return;
      }
      if (!stage.hasPointerCapture(event.pointerId)) stage.setPointerCapture(event.pointerId);
    });
    stage.addEventListener('pointerup', (event) => {
      if (!swipe || swipe.id !== event.pointerId) return;
      const dx = event.clientX - swipe.x;
      const dy = event.clientY - swipe.y;
      swipe = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;
      ignoreClick = true;
      showMedia(mediaIndex + (dx < 0 ? 1 : -1));
    });
    stage.addEventListener('pointercancel', () => {
      swipe = null;
    });
  }

  root.querySelectorAll('[data-size-option]').forEach((el) => {
    el.addEventListener('click', () => setVariant(el.dataset.sizeOption));
  });

  sizeSelect?.addEventListener('change', () => setVariant(sizeSelect.value));

  packSelect?.addEventListener('change', () => setQty(packSelect.value));

  root.querySelectorAll('[data-pack-option]').forEach((el) => {
    el.addEventListener('click', () => setQty(el.dataset.packOption));
  });

  root.querySelectorAll('[data-purchase-option]').forEach((el) => {
    el.addEventListener('click', (event) => {
      if (event.target.closest('select, option, a')) return;
      setMode(el.dataset.purchaseOption);
    });
    el.addEventListener('keydown', (event) => {
      if (event.target.closest('select, input')) return;
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        setMode(el.dataset.purchaseOption);
      }
    });
  });

  root.querySelectorAll('[data-purchase-radio]').forEach((input) => {
    input.addEventListener('change', () => setMode(input.value));
  });

  freqSelect?.addEventListener('change', () => {
    setMode('subscribe');
  });

  root.querySelectorAll('[data-qty-minus]').forEach((button) => {
    button.addEventListener('click', () => setQty(qty - 1));
  });
  root.querySelectorAll('[data-qty-plus]').forEach((button) => {
    button.addEventListener('click', () => setQty(qty + 1));
  });

  sticky?.querySelector('[data-sticky-submit]')?.addEventListener('click', () => {
    purchaseCta?.querySelector('button[type="submit"], button[name="add"]')?.click();
  });

  const openBackInStock = () => {
    const formId = (root.dataset.bisFormId || '').trim();
    if (!formId) return;
    window.omnisend = window.omnisend || [];
    window.omnisend.push(['openForm', formId]);
  };

  root.querySelectorAll('[data-powdi-bis]').forEach((button) => {
    button.addEventListener('click', openBackInStock);
  });

  if (sticky && purchaseCta && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        const hidden = entries.some((entry) => !entry.isIntersecting);
        syncSticky(hidden);
      },
      { threshold: 0.15 }
    );
    observer.observe(purchaseCta);
    mobileQuery.addEventListener('change', () => {
      if (!mobileQuery.matches) syncSticky(false);
    });
  }

  const ratingLink = root.querySelector('[data-rating-jump]');
  ratingLink?.addEventListener('click', (event) => {
    const target = document.getElementById('klientu-atsiliepimai');
    if (!target) return;
    event.preventDefault();
    const desktop = window.matchMedia('(min-width: 990px)').matches;
    const scroller = desktop ? document.querySelector('.page-wrapper') : null;
    const headerHeight = Number.parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
    const current = scroller ? scroller.scrollTop : window.scrollY;
    const top = Math.max(0, current + target.getBoundingClientRect().top - headerHeight - 16);
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    (scroller || window).scrollTo({ top, behavior: reduce ? 'auto' : 'smooth' });
    if (history.replaceState) history.replaceState(null, '', '#klientu-atsiliepimai');
  });

  showMedia(0);
  const activeDays = Number(root.querySelector('.powdi-product__supply.is-active')?.dataset.days) || 0;
  syncFreqSelect(activeDays ? closestPlanId(currentVariant, activeDays) : '');
  neutralizeAppSellingPlanInputs();
  setMode(purchaseMode);
  updatePackFace();
  updatePrices();
})();
